import { FC } from 'react';
import LayOutPageContent from './content';
import LayOutPageContentHeader from './header';
import {
  LayOutPageContentProps,
  LayOutPageContentHeaderProps,
} from '../interface';

export type ILayOutPageContentComponent = FC<LayOutPageContentProps> & {
  Header: FC<LayOutPageContentHeaderProps>;
};

const TransLayOutContentPage = LayOutPageContent as ILayOutPageContentComponent;
TransLayOutContentPage.Header = LayOutPageContentHeader;

export default TransLayOutContentPage;